import { render, staticRenderFns } from "./WindowOptions.vue?vue&type=template&id=4d4e6054&lang=pug&"
import script from "./WindowOptions.vue?vue&type=script&lang=js&"
export * from "./WindowOptions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports